import dynamic from "next/dynamic";

const Snackbar = dynamic(() =>
  import("@material/react-snackbar").then((module) => module.Snackbar)
);

export const SnackbarLazy = (props) => {
  return <Snackbar {...props} />;
};
